import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { BaseComponent } from 'src/app/core/abstracts/base.component';
import { Subject } from 'rxjs';
import { takeUntil, map } from 'rxjs/operators';
import { ResultModel } from 'src/app/core/models/result.model';
declare var $: any;

@Component({
  selector: 'app-school',
  templateUrl: './school.component.html',
  styleUrls: ['./school.component.scss']
})
export class SchoolComponent extends BaseComponent implements OnInit{

  isVisibleAppLoading: boolean = false;

  isVisibleCropModal: boolean = false;

  //callback
  _onImageCropped = null;

  imageChangedEvent = null;

  ngOnInit() {
    this.commonFunctionsService.appLoadingVisible.subscribe(
      next => {
        this.isVisibleAppLoading = next;
      }
    )
    
    this.commonFunctionsService.imageCropVisible.subscribe(
      next => {
        
        if(next){
          this.imageChangedEvent = next.FileEvent;
          this.isVisibleCropModal = next.Visible;
          this._onImageCropped = next.OnImageCropped;
        }
        
      }
    )
    
    this.routeStateService.updateProfilePhoto(this.authService.getData('UserPhoto'));
  }

  ngAfterViewInit(){
    $(document).on('click','.paginate_button.page-item a.page-link, a[href="#"]',function(e){
      e.stopPropagation();
      e.preventDefault();
      return false;
    });
    
  }

  onResultImageCropped(result: ResultModel){
    if(result.Success && this._onImageCropped){
      this._onImageCropped(result.data);
    }
  }

  onHiddenCropModal(){
    this.isVisibleCropModal = false;
    this.imageChangedEvent = null;
  }



}
